/**
 * RNR's Avatar — 8px square-shouldered, never round.
 *
 * Both concept sheets take the harder corners graft and both cut the avatar to it explicitly: a
 * partner's gel is a TILE with an initial on it, at every size, which is what makes a 14px score
 * marker and a 72px pairing square read as the same object. The one round thing left in the app is
 * a shape rather than a corner — the LockPair marker ring, the face scale, the brand mark.
 *
 * The fallback is not an error state — most rows in this app have no picture, so the monogram in the
 * app's own colour is the normal case and has to look deliberate.
 */
import { cn } from '@/lib/utils';
import * as AvatarPrimitive from '@rn-primitives/avatar';

function Avatar({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Root>) {
  return <AvatarPrimitive.Root className={cn('relative size-[34px] shrink-0 overflow-hidden rounded-md', className)} {...props} />;
}

function AvatarImage({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Image>) {
  return <AvatarPrimitive.Image className={cn('aspect-square size-full', className)} {...props} />;
}

function AvatarFallback({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Fallback>) {
  return <AvatarPrimitive.Fallback className={cn('bg-primary size-full flex-row items-center justify-center', className)} {...props} />;
}

export { Avatar, AvatarFallback, AvatarImage };
